import * as React from 'react';
import * as Api from 'src/api';
import * as _ from 'lodash';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import ContentList from 'src/components/Content/list';
import { Content } from 'src/models/content';

export default class ContentContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contents: [],
      pages: 0,
      where: {
        title: '',
        type: '',
      },
    };

    this.fetch = this.fetch.bind(this);
    this.delete = this.delete.bind(this);
  }

  public async fetch({ page, where }: any): Promise<void> {
    const query: any = {
      limit: 10,
      offset: 10 * (page - 1),
      where: where || this.state.where,
    };

    const response: any = await Api.listContents(query);
    const contents: Content[] = response.data;
    const headers = response.headers;
    const pages = Math.ceil(parseInt(headers['x-total-count'], 10) / 10);

    this.setState({
      contents, 
      pages, 
      where: where || this.state.where,
    });
  }

  public async delete(id: number): Promise<any> {
    confirmAlert({
      title: 'Confirmar',
      message: '¿Desea eliminar?',
      buttons: [
        {
          label: 'Si',
          onClick: async () => {
            await Api.deleteContent(id);
            toast.success('El registro fue eliminado');
            this.fetch({ page: 1 });
          },
        },
        {
          label: 'No',
        }
      ]
    });
  }

  public render() {
    return (
      <ContentList
        contents={this.state.contents}
        pages={this.state.pages}
        onPageChange={this.fetch}
        onDelete={this.delete}
      />
    );
  }

  public componentDidMount() {
    this.fetch({ page: 1 });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Content/index.tsx